import React from "react";
import { SocialIcon } from "react-social-icons";
import alessandra from "./pics/alessandra.jpeg";
import timon from "./pics/timon.jpg";
import antonio from "./pics/antonio.jpeg";
import "./AboutUs.css";
import { Link } from "react-router-dom";
import portfolio from "./pics/icon.png";
import antportfolio from "./pics/antonioport.png";

export default function AboutUs() {
  return (
    <div>
      <div className="us-container">
        <div className="us-individual-container">
          <img className="us-pic" src={alessandra} loading="lazy"></img>
          <h5 className="us-name">Alessandra</h5>
          <h6 className="us-city">Berlin</h6>
          <div className="us-social">
            <SocialIcon
              network="linkedin"
              style={{ height: 30, width: 30 }}
              url="https://www.linkedin.com/in/alessandramaffei/"
              bgColor="var(--accent)"
              target="_blank"
            />

            <SocialIcon
              network="github"
              style={{ height: 30, width: 30 }}
              url="https://github.com/a-maffei"
              bgColor="var(--accent)"
              target="_blank"
            />
          </div>
        </div>
        <div className="us-individual-container">
          <img className="us-pic" src={antonio} loading="lazy"></img>
          <h5 className="us-name">Antonio</h5>
          <h6 className="us-city">Stuttgart</h6>
          <div className="us-social">
            <SocialIcon
              network="linkedin"
              style={{ height: 30, width: 30 }}
              url="https://www.linkedin.com/in/antonio-macan-51bb91207/"
              bgColor="var(--accent)"
              target="_blank"
            />
            <SocialIcon
              network="github"
              style={{ height: 30, width: 30 }}
              url="https://github.com/Macanijus"
              bgColor="var(--accent)"
              target="_blank"
            />
            <a
              href="https://antonioportofolio.netlify.app/"
              className=""
              target="_blank"
              title="Antonio's Portfolio"
            >
              <img
                src={antportfolio}
                alt="PC"
                style={{ height: 30, width: 30 }}
              />
            </a>
          </div>
        </div>
        <div className="us-individual-container">
          <img className="us-pic" src={timon} loading="lazy"></img>
          <h5 className="us-name">Timon</h5>
          <h6 className="us-city">Berlin</h6>
          <div className="us-social">
            <SocialIcon
              network="linkedin"
              style={{ height: 30, width: 30 }}
              url="https://www.linkedin.com/in/timonschell/"
              bgColor="var(--accent)"
              target="_blank"
              title="Timon's LinkedIn Account"
            />
            <SocialIcon
              network="github"
              style={{ height: 30, width: 30 }}
              url="https://github.com/Apollosport"
              bgColor="var(--accent)"
              target="_blank"
              title="Timon's Github Account"
            />
            <a
              href="https://timonschell.com/"
              className=""
              target="_blank"
              title="Timon's Portfolio"
            >
              <img src={portfolio} alt="PC" style={{ height: 30, width: 30 }} />
            </a>

            {/* <SocialIcon
              network="xing"
              style={{ height: 30, width: 30 }}
              url="https://www.xing.com/profile/Timon_Schell/"
              bgColor="var(--accent)"
              target="_blank"
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
